<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <img class="leap" src="../../assets/images/logos/leap-skills-black.png" />
    <div class="l-container l-pad">
      <img src="../../assets/images/logos/logo__unite.png" class="unite-logo" />
      <h4 class="l__splash" style="margin-bottom:20px;">
        What describes you best?
      </h4>
      <a class="m-btn m-btn__primary__floating" @click="studentSelected()"
        >I'm a Student <span class="m-btn__arrow"></span
      ></a>
      <a class="m-btn m-btn__primary__floating" @click="teacherSelected()"
        >I'm a Teacher <span class="m-btn__arrow"></span
      ></a>

      <a class="m-btn m-btn__primary__floating" @click="parentSelected()"
        >I'm a Parent <span class="m-btn__arrow"></span
      ></a>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { UserTypes } from '../../contants'
import MainFooter from '../../components/MainFooter'
export default {
  data () {
    return {}
  },
  methods: {
    ...mapActions(['resetState', 'saveUserType']),
    studentSelected () {
      this.setUserType(UserTypes.STUDENT)
      this.$router.push({ name: 'start' })
    },
    parentSelected () {
      this.setUserType(UserTypes.PARENT)
      this.$router.push({ name: 'parent' })
    },
    teacherSelected () {
      this.setUserType(UserTypes.TEACHER)
      this.$router.push({ name: 'teacher' })
    },
    setUserType () {
      this.resetState()
      this.saveUserType(UserTypes.TEACHER)
    }
  },
  components: {
    MainFooter
  },
  name: 'UserTypeChoice'
}
</script>

<style scoped lang="scss">
img.leap {
  width: 150px;
  height: auto;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 125px;
}

.unite-logo {
  width: 250px;
}

h4 {
  margin-bottom: 25px;
  position: relative;
}

.m-btn__arrow {
  display: inline-block;
  margin-top: -0.4em;
}
.m-btn__primary__floating {
  margin-right: 20px;
}

@media (min-width: 900px) {
  .l__splash {
    width: 60%;
  }
}

@media (max-width: 899px) {
  img.leap {
    width: 70px;
    height: auto;
    position: absolute;
    top: 10px;
    right: 20px;
  }
  .unite-logo {
    width: 15%;
  }
  .l__splash {
    width: 100%;
    font-size: 1.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Survey/UserTypeChoice.vue